import * as React from 'react';
import { Radio } from 'antd';

import { ArchivedFilterOptions } from 'common/helpers/utils';
import { InputLabelWithTooltip } from '../../form/components/InputLabelWithTooltip';
import { Antd3Form, Antd3FormModel } from '../antd3';

const ALL_VALUE = 'all';

interface Props extends Antd3FormModel {
    defaultValue?: boolean | string;
    required?: boolean;
}

export const ArchivedRadioButtons = ({ form, defaultValue, required = false }: Props) => {
    const initialValue =
        defaultValue === undefined
            ? ArchivedFilterOptions.Unarchived
            : defaultValue === true || defaultValue === ArchivedFilterOptions.Archived
            ? ArchivedFilterOptions.Archived
            : defaultValue === false || defaultValue === ArchivedFilterOptions.Unarchived
            ? ArchivedFilterOptions.Unarchived
            : ALL_VALUE;

    React.useEffect(() => {
        form.setFieldsValue({ showArchived: initialValue });
    }, [defaultValue]);

    return (
        <Antd3Form.Item label={<InputLabelWithTooltip label="Archive Status" />}>
            {form.getFieldDecorator('showArchived', {
                rules: [{ required, message: 'Please choose an archive status' }],
                initialValue,
            })(
                <Radio.Group name="showArchived">
                    <Radio value={ArchivedFilterOptions.Unarchived}>Unarchived</Radio>
                    <Radio value={ArchivedFilterOptions.Archived}>Archived</Radio>
                    <Radio value={ALL_VALUE}>All</Radio>
                </Radio.Group>,
            )}
        </Antd3Form.Item>
    );
};
